export default function() {
  const widgetName = 'cardWidgetImageCards';
  const widgetOpts = cardWidgetImageCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
        // add animate.css classes
        const target = document.getElementById(`${widgetName}`);
        let options = {
          root: null,
          rootMargin: "0px",
          threshold: [0.5],
        };
        let callback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio > 0.5) {
              $(entry.target).addClass('animate__animated animate__fadeInRight');
            }
          });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(target);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}